import { createFileRoute } from "@tanstack/react-router";
import { IndustriPage, industriHead } from "@/pages/IndustriPage";

export const Route = createFileRoute("/brancher/industri-produktion")({
  head: () => industriHead("da"),
  component: () => <IndustriPage locale="da" />,
});
